import { render } from "./TillyMascot.vue?vue&type=template&id=a36ceff8&scoped=true"
import script from "./TillyMascot.vue?vue&type=script&lang=js"
export * from "./TillyMascot.vue?vue&type=script&lang=js"

import "./TillyMascot.vue?vue&type=style&index=0&id=a36ceff8&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36ceff8"]])

export default __exports__